import React from "react";
import "./index.css";
import cn from "classnames";
import Textarea from "../../../layout/Textarea/Textarea";
import QRCode from "../../../layout/QRCode";
import ImageUpload from "../../../layout/ImageUpload";
import {newsletterLayoutTypes} from "../../../data/constants";
import {useSetting} from "../../../contexts/setting";
import {useEdits} from "../../../contexts/edits";
import {useImages} from "../../../contexts/images";

// QRcodePrint (10x10 inside crop marks + outside 3-5mm)
const QRcodePrint = ({id, zoom}) => {
  const {layoutOption, type} = useSetting();
  const {titles, subtitles, links} = useEdits();
  const {uploadImages} = useImages();

  const isNewsletter = newsletterLayoutTypes.includes(type.value);
  const newsletterClass = isNewsletter ? "newsletter" : "";
  const templateClass = cn("template", `layout-${layoutOption}`, newsletterClass);

  const title = titles[id] || titles.main;
  const subtitle = subtitles[id] || subtitles.main;
  const link = links[id] || links.main;
  const hasCustomQR1 = Boolean(uploadImages?.["custom-qr-1"]);
  const Slot1 = hasCustomQR1 ? <ImageUpload id={"custom-qr-1"} /> : <QRCode value={link} />;

  return (
    <>
      <div id={id} className={templateClass} style={{"--zoom-level": zoom}}>
        <div>
          <div className="content">
            <div className="print-area">
              <div className="print-area__border" aria-hidden="true" />
              <div className="title" data-node-id="229:29">
                <Textarea id={id} text={title} />
              </div>
              <div className="qr-code" data-node-id="229:30">{Slot1}</div>
              <h3 className="subtitle" data-node-id="229:32">
                <Textarea id={id} lines="1" text={subtitle} />
              </h3>
            </div>
            <div className="crop-marks" aria-hidden="true">
              <div className="line v-tl" />
              <div className="line h-tl" />
              <div className="line v-tr" />
              <div className="line h-tr" />
              <div className="line v-bl" />
              <div className="line h-bl" />
              <div className="line v-br" />
              <div className="line h-br" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default QRcodePrint;


